import { authFetch, apiErrorMessage } from './authFetch';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';

export interface LocationItem {
    ghl_id: string;
    name: string;
    emr: string;
    sync_active: boolean;
    /** Practice CRM: 'ghl' (default) or 'av_emr'. Older backends omit it → treat as 'ghl'. */
    crm?: PracticeCrm;
}

export type PracticeCrm = 'ghl' | 'av_emr';

export const locationsApi = {
    async list(): Promise<LocationItem[]> {
        const response = await authFetch(`${API_BASE_URL}/locations`);
        if (!response.ok) throw new Error('Failed to load locations');
        return response.json();
    },

    async setSyncActive(ghlId: string, emr: string, isSyncActive: boolean): Promise<LocationItem> {
        const response = await authFetch(
            `${API_BASE_URL}/locations/${encodeURIComponent(ghlId)}/sync-active`,
            {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ is_sync_active: isSyncActive, emr }),
            },
        );
        if (!response.ok) {
            const body = await response.json().catch(() => null);
            throw new Error(apiErrorMessage(body, 'Failed to update data sync'));
        }
        return response.json();
    },
};
